module.exports = __webpack_public_path__ + "img/icon_kf.a168a952.png";